<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="入库单号:" prop="stock_in_sn">
        <el-col :span="7">
          <el-input v-model="form.stock_in_sn"></el-input>
        </el-col>
        <el-col :span="2" style="margin-left: 20px">
          <el-button type="primary" @click="randomCode">新建单号</el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="产品信息:" prop="product_sn">
        <el-col :span="3">
          <el-input v-model="form.product_sn" readonly></el-input>
        </el-col>
        <el-col class="line" :span="1" style="text-align: center">-</el-col>
        <el-col :span="3">
          <el-input v-model="form.product_name" readonly class="readonlyclass"></el-input>
        </el-col>
        <el-col :span="2" style="margin-left: 20px">
          <el-button type="primary" @click="selectProduct()">选择</el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="生产批次号:" prop="production_batch">
        <el-col :span="8">
          <el-input v-model="form.production_batch"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="扫码方式:" prop="type">
        <el-radio v-model="form.type" label="1">单码扫描</el-radio>
        <el-radio v-model="form.type" label="2">流水号区间</el-radio>
      </el-form-item>
      <!--  <el-form-item label="标签类型:" prop="type">
        <el-select v-model="form.type" size="small">
          <el-option :value="1" label='大标'></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="生产日期">
        <el-col :span="8">
          <el-date-picker type="date" placeholder="选择日期" v-model="form.production_date" @change="selectStart" style="width: 100%;"></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="有效期至">
        <el-col :span="8">
          <el-date-picker type="date" placeholder="选择日期" v-model="form.expiring_date" style="width: 100%;"></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="入库仓库:" prop="warehouse_sn">
        <el-select v-model="form.warehouse_sn" size="small">
          <el-option v-for=" i in addArray" :key="i.warehouse_sn" :label="i.warehouse_name" :value="i.warehouse_sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="扫描二维码:" prop="logistics_code" v-if="form.type==1">
        <el-col :span="8">
          <el-input v-model="form.logistics_code" @keyup.enter.native="save('form')"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="流水号区间:" prop="start_num" v-if="form.type==2">
        <el-col :span="3">
          <el-input v-model="form.start_num" placeholder="开始流水号"></el-input>
        </el-col>
        <el-col class="line" :span="1" style="text-align: center">-</el-col>
        <el-col :span="3" prop="end_num">
          <el-input v-model="form.end_num" placeholder="结束流水号"></el-input>
        </el-col>
        <el-col :span="5" style="padding-left:10px">
          数量:{{form.end_num-form.start_num+1}}
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :span="8">
          <el-button type="primary" @click="save('form')">保存</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <selectProduct v-if="dialogVisible" v-on:handleClose="dialogVisible = false" v-on:pushData="getChildData"></selectProduct>
    <el-dialog title="处理结果" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="code" label="流水号" ></el-table-column>
        <el-table-column property="message" label="原因"></el-table-column>
      </el-table>
    </el-dialog>
  </div>

</template>
<script>
import selectProduct from "./selectProduct.vue";
import { Message } from "element-ui";
export default {
  name: "instockScan",
  data() {
    return {
      dialogVisible: false,
      form: {
        type: "1",
        warehouse_sn: "",
        stock_in_sn: "",
        product_sn: "",
        production_batch: "",
        start_num: "",
        end_num: "",
      },
      rules: {
        stock_in_sn: [{ required: true, message: "入库单号不能为空！" }],
        product_sn: [{ required: true, message: "产品信息不能为空！" }],
        warehouse_sn: [{ required: true, message: "请选择仓库" }],
        start_num: [{ required: true, message: "请输入开始流水号" }],
        end_num: [{ required: true, message: "请输入开始结束流水号" }],
      },
      addArray: [], //直接添加仓库
      product_id: null,
      expiring_date: null,
      gridData: [],
      dialogTableVisible: false,
    };
  },
  created() {
    this.getScanStock();
    this.randomCode();
    this.getConfigInfo();
  },
  components: { selectProduct },
  methods: {
    //获取基础配置(生产批次号的控制是否为必填)
    getConfigInfo() {
      this.$get("logistics", "/configs", {
        lang: "",
      })
        .then((res) => {
          if (res.data.production_batch_on_off == 0) {
            this.rules.production_batch = [];
          } else if (res.data.production_batch_on_off == 1) {
            this.rules.production_batch = [
              { required: true, message: "生产批次号不能为空" },
            ];
            this.rules.production_batch = [
              {
                required: true,
                message: "生产批次号不能为空",
                trigger: "blur",
              },
            ];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //获取仓库列表(扫二维码)
    getScanStock() {
      this.$get("logistics", "/warehouses.all", {
        lang: "",
      })
        .then((res) => {
          this.scanArray = res.data;
          this.addArray = res.data;
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].is_default == 1) {
              this.form.warehouse_sn = res.data[i].warehouse_sn;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //选择产品
    selectProduct() {
      this.dialogVisible = true;
    },
    //直接添加获取子组件传过来的产品信息
    getChildData(val) {
      this.form.product_sn = val.product_sn;
      this.form.product_name = val.product_name;
      this.expirationtime = val.expirationtime;
      this.form.production_batch = val.production_batch;
    },
    /*生成随机的单号*/
    randomCode() {
      var randomNum = Math.floor(Math.random() * 9999);
      var myDate = new Date();
      var tY = myDate.getFullYear();
      var tM = myDate.getMonth() + 1;
      if (tM >= 1 && tM <= 9) {
        tM = "0" + tM;
      }
      var tD = myDate.getDate();
      if (tD >= 1 && tD <= 9) {
        tD = "0" + tD;
      }
      this.form.stock_in_sn = "RK" + tY + tM + tD + randomNum;
      this.$forceUpdate();
    },
    //选择生产日期
    selectStart(val) {
      let statTime = this.moment(val).format("YYYY-MM-DD");
      // expirationtime
      this.form.expiring_date = this.calculateTime(
        statTime,
        this.expirationtime
      );
      this.$forceUpdate();
    },
    //根据选择的开始时间和有效期来判断有效期至
    calculateTime(date, monthNum) {
      var dateArr = date.split("-");
      var year = dateArr[0]; //获取当前日期的年份
      var month = dateArr[1]; //获取当前日期的月份
      var day = dateArr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + parseInt(monthNum);
      if (month2 > 12) {
        year2 =
          parseInt(year2) +
          parseInt(parseInt(month2) / 12 == 0 ? 1 : parseInt(monthNum) / 12);
        if (parseInt(month2) % 12 == 0) {
          month2 = 12;
        } else {
          month2 = parseInt(month2) % 12;
        }
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = "0" + month2;
      }
      var t2 = year2 + "-" + month2 + "-" + day2;
      return this.getNextDate(t2, -1);
    },
    getNextDate(date, day) {
      var dd = new Date(date);
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    //直接保存
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.form.type == 1) {
          this.$post("logistics", "/incodewarehouses", {
            expiring_date: this.expiring_date,
            ...this.form,
          })
            .then((res) => {
              Message({
                message: "添加成功",
                type: "success",
              });
            })
            .catch((error) => {
              Message({
                type: "error",
                message: error.data.message,
              });
            });
        } else {
          this.$post("logistics", "/inmorecodewarehouses", {
            expiring_date: this.expiring_date,
            ...this.form,
          })
            .then((res) => {
              if(res.fail_num>=1){
                     this.gridData=res.text
                   this.dialogTableVisible=true
              }else{
               Message({
                  message: '操作成功',
                  type: "success",
                });
              } 
            })
            .catch((error) => {
            
              Message({
                type: "error",
                message: error.message,
              });
            });
        }
      });
    },
  },
};
</script>